import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import me1 from '../../images/formal-removebg.png';
import { Container, Divider, Link } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';
import './Introduction.css';

const Introduction = () => {


    // useEffect(() => {
    //     (function () {
    //         var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
    //             window.setTimeout(callback, 1000 / 60);
    //         };
    //         window.requestAnimationFrame = requestAnimationFrame;
    //     })();

    //     // Terrain stuff.
    //     var background = document.getElementById("bgCanvas"),
    //         bgCtx = background.getContext("2d"),
    //         width = window.innerWidth,
    //         // height = document.body.offsetHeight;
    //         height = 450;

    //     // (height < 400) && height = 400;

    //     background.width = width;
    //     background.height = height;

    //     function Terrain(options) {
    //         options = options || {};
    //         this.terrain = document.createElement("canvas");
    //         this.terCtx = this.terrain.getContext("2d");
    //         this.scrollDelay = options.scrollDelay || 90;
    //         this.lastScroll = new Date().getTime();

    //         this.terrain.width = width;
    //         this.terrain.height = height;
    //         this.fillStyle = options.fillStyle || "#7f8c8d";
    //         this.mHeight = options.mHeight || height;

    //         // generate
    //         this.points = [];

    //         var displacement = options.displacement || 140,
    //             power = Math.pow(2, Math.ceil(Math.log(width) / (Math.log(2))));

    //         // set the start height and end height for the terrain
    //         this.points[0] = this.mHeight;//(this.mHeight - (Math.random() * this.mHeight / 2)) - displacement;
    //         this.points[power] = this.points[0];

    //         // create the rest of the points
    //         for (var i = 1; i < power; i *= 2) {
    //             for (var j = (power / i) / 2; j < power; j += power / i) {
    //                 this.points[j] = ((this.points[j - (power / i) / 2] + this.points[j + (power / i) / 2]) / 2) + Math.floor(Math.random() * -displacement + displacement);
    //             }
    //             displacement *= 0.6;
    //         }

    //         document.body.appendChild(this.terrain);
    //     }

    //     Terrain.prototype.update = function () {
    //         // draw the terrain
    //         this.terCtx.clearRect(0, 0, width, height);
    //         this.terCtx.fillStyle = this.fillStyle;

    //         if (new Date().getTime() > this.lastScroll + this.scrollDelay) {
    //             this.lastScroll = new Date().getTime();
    //             this.points.push(this.points.shift());
    //         }

    //         this.terCtx.beginPath();
    //         for (var i = 0; i <= width; i++) {
    //             if (i === 0) {
    //                 this.terCtx.moveTo(0, this.points[0]);
    //             } else if (this.points[i] !== undefined) {
    //                 this.terCtx.lineTo(i, this.points[i]);
    //             }
    //         }

    //         this.terCtx.lineTo(width, this.terrain.height);
    //         this.terCtx.lineTo(0, this.terrain.height);
    //         this.terCtx.lineTo(0, this.points[0]);
    //         this.terCtx.fill();
    //     }


    //     // Second canvas used for the stars
    //     bgCtx.fillStyle = '#05004c';
    //     bgCtx.fillStyle = '#212529';
    //     bgCtx.fillRect(0, 0, width, height);


    //     var entities = [];


    //     entities.push(new Terrain({ mHeight: (height / 2) - 120 }));
    //     entities.push(new Terrain({ displacement: 120, scrollDelay: 50, fillStyle: "rgb(149, 165, 166)", mHeight: (height / 2) - 60 }));
    //     entities.push(new Terrain({ displacement: 100, scrollDelay: 20, fillStyle: "rgb(45, 52, 54)", mHeight: height / 2 }));

    //     //animate background
    //     function animate() {
    //         bgCtx.fillStyle = '#F5F6F7';
    //         bgCtx.fillRect(0, 0, width, height);
    //         bgCtx.fillStyle = '#ffffff';
    //         bgCtx.strokeStyle = '#ffffff';

    //         var entLen = entities.length;

    //         while (entLen--) {
    //             entities[entLen].update();
    //         }
    //         requestAnimationFrame(animate);
    //     }
    //     animate();
    // }, [])

    return (
        <Box id="about-me" sx={{ flexGrow: 1, }}>
            {/* <canvas id='bgCanvas' /> */}
            <Container sx={{ textAlign: 'center', display: 'box', }}>
                <img
                    data-aos="fade-up"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000"
                    style={{ width: '200px', height: '200px', borderRadius: '50%', border: '1px solid #FFFFFF4E', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px', marginTop: '100px', zIndex: 999 }}
                    src={me1} alt="me"
                />

                <Divider
                    data-aos="fade-up"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000"
                    sx={{ width: '100px', p: 0, m: '-2px auto', border: '1px solid #FFFFFF4E' }}
                />
                <Divider
                    data-aos="fade-up"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000"
                    sx={{ width: '150px', p: 0, m: '4px auto', border: '1px solid #FFFFFF4E' }}
                />



                <Typography data-aos="fade-up"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="3000" sx={{ px: 5, py: 2, lineHeight: '25px', letterSpacing: '2px', textAlign: 'justify', fontWeight: '300' }} variant="p" component="div">
                    I’m a professional Full Stack Developer or MERN Stack Developer. I have completed my graduation with a B.Sc (Engg.) and an M.Sc (Engg.) in Information and Communication Technology (ICT) from Comilla University. Currently, I'm working as a Software Engineer (JavaScript) for <Link style={{ textDecoration: 'none', fontWeight: 'bold', color: '#B73361F8' }} href='https://www.profecialinks.com/' target="_blank">Profecia Links Consulting Pvt. Ltd</Link>. I'm a passionate learner who is always interested in improving self-skills and is an expert on JavaScript, TypeScript, and JavaScript frameworks: ReactJS, NodeJS, and ExpressJS. I also have solid foundations in HTML5, CSS3, Bootstrap, Tailwind CSS, ES6, MongoDB, Three.js, Socket.io, Redux, Context API, Restful API, Axios, Firebase Authentication, JWT, SASS, Styled Components, Material UI, and Wordpress Theme Customization.
                </Typography>

                <Box data-aos="fade-up"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="1000" sx={{ mt: 2 }}>
                    <Link href="https://web.facebook.com/md.akramul.hoque.likhon/" target="_blank" underline="none" sx={{ color: 'gray' }}>
                        <FacebookIcon />
                    </Link>
                    <Link href="https://www.instagram.com/l_i_k_h_o_n_01/?hl=en" target="_blank" underline="none" sx={{ color: 'gray', mx: 1 }}>
                        <InstagramIcon />
                    </Link>
                    <Link href="https://www.linkedin.com/in/mdakramulhoque/" target="_blank" underline="none" sx={{ color: 'gray' }}>
                        <LinkedInIcon />
                    </Link>
                    <Link href="https://twitter.com/AurthohinL" target="_blank" underline="none" sx={{ color: 'gray', mx: 1 }}>
                        <TwitterIcon />
                    </Link>
                    <Link href="https://github.com/AH-Likhon" target="_blank" underline="none" sx={{ color: 'gray' }}>
                        <GitHubIcon />
                    </Link>
                </Box>

            </Container>
        </Box>
    );
};

export default Introduction;